var _linearGradient, _linearGradient2, _radialGradient;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQemu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58.177,
    height: 57.878,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#bebebe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff771c",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e72404",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 142.819,
    y1: 831.523,
    x2: 142.819,
    y2: 878.907
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "f",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.11867 0 0 1.11867 -1.95 -2.03)",
    x1: 37.341,
    y1: 22.629,
    x2: 37.341,
    y2: 61.741
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "d",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.00075 .7155 -.594 .00062 95.038 -44.486)",
    cx: 98.002,
    cy: 86.445,
    fx: 98.002,
    fy: 86.445,
    r: 55.859
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44.525 17.108c-15.513 0-28.096 12.506-28.096 27.94 0 15.433 12.583 27.939 28.096 27.939 5.076 0 9.829-1.334 13.938-3.677l1.462 3.677H71.254l-4.431-10.953a27.725 27.725 0 0 0 5.783-16.987c0-15.433-12.568-27.939-28.081-27.939z",
    style: {
      fill: "url(#d)",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "translate(-15.429 -16.108)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.52623 0 0 .6497 -46.258 -538.41)",
    d: "M177.857 856.29c0 13.61-15.83 24.644-35.357 24.644s-35.357-11.033-35.357-24.643c0-13.61 15.83-24.643 35.357-24.643s35.357 11.033 35.357 24.643z",
    style: {
      fill: "url(#e)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      fillOpacity: 0.88235294,
      stroke: "none"
    },
    d: "M59.222 33.202h1.111v.984h-1.111z",
    transform: "translate(-15.429 -16.108)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.50284 0 0 .50284 -26.491 -418.101)",
    d: "M122.228 856.393a6.566 6.566 0 1 1-13.132 0 6.566 6.566 0 0 1 13.132 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.98975 .14282 -.18973 .98184 -15.429 -16.108)",
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "M46.111 24.066H65.04v2.766H46.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "M58.135 33.942h3.302v1.191h-3.302z",
    transform: "translate(-15.429 -16.108)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.063 21.719c-.03 1.099-1.949.15-2.032 1.406-2.124-.946.181 1.435-.031 1.656h-.031l-.157-.031c-.102-.037-.248-.083-.468-.219-1.484 1.182-1.502 3.64-3.032 5-1.003 2.165-1.266 4.495-2 6.75-.36 2.164-.661 4.334-.125 6.5.162 1.761-.353 4.17 1.25 5.407 2.378 1.952 4.348 4.4 6.344 6.75 3.113 3.83 5.875 7.96 8.313 12.25l.031.062.813 1.719c.014.034.016.061.03.094.132.277.274.482.438.53a90.042 90.042 0 0 1-.719-6.125c-.795-5.174-3.352-9.873-4.312-15-.021-.154-.04-.31-.063-.468-.009-.063-.022-.124-.03-.188v-.093l-.063-.563h-.032c-.314-2.536-.404-5.268 1.438-7.25 1.88-1.897 4.672-2.37 6.938-3.687a7.45 7.45 0 0 1 1.562-.719c.004-.002.027.002.031 0 1.568-.484 3.247-.452 4.875-.188.024.005.039-.003.063 0 .148.025.321.065.468.094 1.193.107 3.57.573 4-.25-1.645-1.4-3.996-1.324-6-1.875-.317-.057-.703-.12-1.093-.156l-1.969-.438-.5-.124v.03l-7.031-1.374a3.384 3.384 0 0 0-.344-.282l6.875.844v-.031c.241.054.477.097.719.125v.031l4.843.875c.836.312 1.696.542 2.532.594 1.379.2 3.141 2.276 3.593 2.375-.221-2.166-2.392-3.146-4.187-3.781-2.097-1.02-5.23-.993-5.563-3.813a6.415 6.415 0 0 0-.28-.562l-.813-1.094h.031c-1.115-1.316-2.676-2.29-4.344-2.656-1.655-.572-3.53-1.148-5.281-1.375-.594 1.749-1.26-1.368-2.688-.438-1.252.149-1.067.481-2-.312zm9 5.093c.453-.011.979.07 1.5.25 1.389.48 2.297 1.51 2.03 2.282-.266.771-1.61.98-3 .5-1.388-.48-2.297-1.479-2.03-2.25.166-.483.744-.762 1.5-.782z",
    style: {
      fill: "url(#f)",
      fillOpacity: 1
    },
    transform: "translate(-15.429 -16.108)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      fillOpacity: 0.88235294,
      stroke: "none"
    },
    d: "M60.619 34.631h.159v.19h-.159zM60.476 34.456h.016v.206h-.016z",
    transform: "translate(-15.429 -16.108)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQemu);
export default __webpack_public_path__ + "static/media/qemu.5ec20db9d92110f6ddb8cb1cf75229cc.svg";
export { ForwardRef as ReactComponent };